import { extendTheme } from "@chakra-ui/react";
import textStyle from "./ThemeStyle";

export const theme = extendTheme( { textStyle } )

